import { NgModule } from '@angular/core';
import { BillingBackend } from './billing.backend';
import { BillingService } from './billing.service';

@NgModule({
  providers: [BillingService, BillingBackend],
})
export class BillingModule {}
